import { PaddingType } from 'common/types/styleTypes'
import {
  backgroundColorCss,
  borderCss,
  FontProps,
  fontCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileFontCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import styled, { css } from 'styled-components'

type BlogPostContentTableUiProps = BorderEntityInterface & {
  backgroundColor?: string
  mobileBackgroundColor?: string
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
} & FontProps

const ContentTableUi = styled.div<BlogPostContentTableUiProps>`
  ${backgroundColorCss}
  ${paddingsCss}
  ${fontCss}
  ${borderCss}
  ${p => p.theme.phone} {
    ${mobileBackgroundColorCss}
    ${mobilePaddingsCss}
    ${mobileBorderCss}
    ${mobileFontCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBackgroundColorCss}
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileFontCss}
    `}
`

export default ContentTableUi
